// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fYna5ODmBmfXtRIBaMAq {
	background-color: var(--gray);
	border-radius: 12px;
	display: flex;
	flex-direction: column;
	padding: 16px;
}
@media (max-width: 767px) {
.fYna5ODmBmfXtRIBaMAq {
		height: 224px;
}
	}
.ja8k37qRN1zzTwaHIZKw {
	display: flex;
	justify-content: space-between;
	margin-bottom: 28px;
}
@media (max-width: 767px) {
.ja8k37qRN1zzTwaHIZKw {
		flex: 1;
}
	}
.U2Y335BNN4GbwPyAeJIO {
	font-size: 16px;
	letter-spacing: -0.04em;
	line-height: 24px;
	width: 220px;
}
.YECem4hiTwHJV4E5sCUe {
	margin-top: 20px;
}
.aFOIxRWTZLSlDJMVsvLQ {
	color: #078f00;
	text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/pages/VESISPage/NoActiveLock/NoActiveLock.pcss"],"names":[],"mappings":"AAEA;CACC,6BAA6B;CAC7B,mBAAmB;CACnB,aAAa;CACb,sBAAsB;CACtB,aAAa;AAKd;AAHC;AAPD;EAQE,aAAa;AAEf;CADC;AAGD;CACC,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AAKpB;AAHC;AALD;EAME,OAAO;AAET;CADC;AAGD;CACC,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,YAAY;AACb;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,cAAc;CACd,0BAA0B;AAC3B","sourcesContent":["@import '../../../stylesheets/media-queries.pcss';\n\n.container {\n\tbackground-color: var(--gray);\n\tborder-radius: 12px;\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding: 16px;\n\n\t@media (--mobile) {\n\t\theight: 224px;\n\t}\n}\n\n.content {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 28px;\n\n\t@media (--mobile) {\n\t\tflex: 1;\n\t}\n}\n\n.text {\n\tfont-size: 16px;\n\tletter-spacing: -0.04em;\n\tline-height: 24px;\n\twidth: 220px;\n}\n\n.claim {\n\tmargin-top: 20px;\n}\n\n.link {\n\tcolor: #078f00;\n\ttext-decoration: underline;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `fYna5ODmBmfXtRIBaMAq`,
	"content": `ja8k37qRN1zzTwaHIZKw`,
	"text": `U2Y335BNN4GbwPyAeJIO`,
	"claim": `YECem4hiTwHJV4E5sCUe`,
	"link": `aFOIxRWTZLSlDJMVsvLQ`
};
export default ___CSS_LOADER_EXPORT___;
